// styles
import { profile, Advisors } from "./Profile";
import styles from "./Team.module.css";
import Open from "../../../assets/Team/Open.png";
import clsx from "clsx";


const TeamLandingPage = () => {
  
  const TeamMembers = ({ photo, name, title, social, des }) => (
    <div className={styles["flip-box"]}>
      <div className={styles["flip-box-inner"]}>
        <div className={styles["flip-box-front"]}>
          <img className={clsx("img-fluid", styles["team-member-image"])}
            src={photo}
            alt={name}
          />
        </div>
        <div className={styles["flip-box-back"]}>
          <div className={styles["containAll"]}>
            <span className={styles["brightness"]}>
              <img className={clsx("img-fluid", styles["team-member-image"])}
                src={photo}
                alt={name}
              />
            </span>
            <div className={styles["bottom-left"]}>
              <div className={styles["container-name"]}>
                <div className={styles["nameCard"]}>
                  {name}
                </div>
                <div className={styles["titleCard"]}>
                  {title}
                </div>
              </div>
            </div>
            <div className={styles["top-right"]}>
              {social &&
                (<a href={social} target="_blank" rel="noreferrer">
                  <img
                    style={{ cursor: 'pointer' }}
                    src={Open}
                    alt={name}
                  />
                </a>)
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={clsx("container-fluid", styles["landingPageContainer"])}>
      <div className="container pb-5">
        <div className={styles["team-page-title"]}>
          MEET THE TEAM
        </div>
      </div>
      <div>
        <div className='row'>
          {profile.map((profile) => (
            <div key={profile.name} className='col-3 nopadding'>
              <TeamMembers
                photo={profile.photo}
                name={profile.name}
                title={profile.title}
                social={profile.linkedin && profile.linkedin}
                des={profile.des} />
            </div>
          ))}
        </div>
      </div>
      <div className={styles["team-page-title_2"]}>
        Advisors
      </div>
      <div>
        <div className='row'>
          {Advisors.map((profile) => (
            <div key={profile.name} className='col-3 nopadding'>
              <TeamMembers
                photo={profile.photo}
                name={profile.name}
                title={profile.title}
                social={profile.linkedin || profile.twitter}
                des={profile.des} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TeamLandingPage
